import { render, staticRenderFns } from "./LocalitaCombo.vue?vue&type=template&id=6a4bfa18"
import script from "./LocalitaCombo.vue?vue&type=script&lang=js"
export * from "./LocalitaCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports